// extracted by mini-css-extract-plugin
export default {"action_button":"tableButtons_action_button__eUkMe"};